import { gql } from '@apollo/client'
import { BOUNDING_BOXES_FRAGMENT } from './BoundingBoxesFragment'
import { SIMPLE_PRODUCT_FRAGMENT } from './SimpleProductFragment'

export const MERCHANDISER_DISPLAY_SCAN_IMAGE_FRAGMENT = gql`
  fragment MerchandiserDisplayScanImage on MerchandiserDisplayScanImage {
    id
    url
    boundingBoxSet {
      ...BoundingBoxes
    }
    products {
      ...SimpleProduct
    }
    flagged {
      level
      reason
      reasonType
      moreInfo
      flaggedBy {
        email
      }
      levelRaisedBy {
        email
        firstName
        lastName
      }
      date
    }
    protectedBoxes {
      id
    }
  }
  ${BOUNDING_BOXES_FRAGMENT}
  ${SIMPLE_PRODUCT_FRAGMENT}
`
